export const PERMISSIONS_NAMES = Object.freeze({
  BROKERS_BLOCKLIST: 'Blocklist Corretores',
  STATUS_CHANGE: 'Alteração de Status',
  USER: 'Usuário',
  INSUREDS: 'Associados',
  QUOTATIONS: 'Cotações',
  QUOTATIONS_RCVAT: 'Cotações RCVAT',
  QUOTATIONS_LIFE: 'Cotações Vida',
  VEHICLES: 'Veículos',
  CONSULTANCY: 'Assessoria',
  COMISSION: 'Comissão',
  DASHBOARD: 'Dashboard',
  COMPANY: 'Empresa',
  INSPECTIONS: 'Vistorias',
  BROKER_ACCOUNT: 'Conta Corrente',
  PRE_REGISTER_BROKERS: 'Pré-Cadastro Corretoras',
  INTEGRATIONS: 'Integrações',
  ANTI_FRAUD: 'Antifraude',
  MICROLIFE: 'Microvida',
  MESSAGING: 'Mensageria',
  AUTO_ROUTINES: 'Rotinas Auto',
  ANNUAL_AUTO: 'Auto Anual',
  PRIOR_INSPECTION: 'Vistoria Prévia',
  BROKER_ACCOUNT_USAGE: 'Uso da Conta Corrente',
  BROKER: 'Corretora',
  AUTO_INDIVIDUAL: 'Auto Individual',
  AUTO_ENDORSEMENT: 'Endosso Automóvel',
  PAYMENT_REPORT: 'Pagamentos',
  FINANCIAL_PANEL: 'Painel Financeiro',
  EVENTS: 'Eventos',
  CLOSING: 'Fechamento',
  CONSOLIDATED: 'Consolidado',
  SUPPLIER: 'Fornecedor',
  VEHICLES_GROUP: 'Grupo de Veículos',
  TABELS: 'Tabelas',
  ORIGIN_SYSTEM: 'Origem da Cotação',
  I4PRO: 'I4Pro',
  CONGENERS: 'Congêneres',
  PROPOSAL_REFUSE_REASONS: 'Recusa de Proposta',
  COVENANT: 'Convênio',
  RENEWALS: 'Renovações',
});

export const PERMISSIONS_ACTIONS = Object.freeze({
  CHANGE_BROKER: 'Permitir alterar Corretora',
  CHANGE_PROPOSAL_BROKER: 'Permitir alterar corretora da proposta',
  REJECT_BROKER: 'Recusa Corretora',
  EDIT_CONTACT_INFO_AFTER_SUBMISSION:
    'Permitir alterar dados de contato após transmissão',
  EDIT_AND_TRANSMIT_PROPOSAL: 'Editar e transmitir proposta',
  BILLETS_CANCEL: 'Pode cancelar boletos',
  BILLETS_DELETE: 'Pode excluir boletos',
  BILLETS_DELETE_SHIPPING: 'Pode excluir boleto remessa',
  BILLETS_EDIT: 'Pode editar boletos',
  BILLETS_EDIT_DATA: 'Pode editar dados do boleto',
  BILLETS_EDIT_DATA_SHIPPING: 'Pode editar boleto remessa',
  BROKER_REFUSE: 'Recusa Corretora',
  CHARGE_CLEAR: 'Pode baixar cobrança',
  COMPLETE_READ: 'Leitura Completa',
  FINANCIAL_COMPLETE_READ: 'Leitura Financeiro Completa',
  FINANCIAL_READ: 'Leitura Financeiro',
  SHOW_INSPECTION: 'Visualizar Vistoria',
  APPROVE_WITHOUT_INSPECTION: 'Aprovar proposta sem vistoria',
  LOGS_READ: 'Visualizar Logs',
  MESSAGING_RESEND: 'Reenviar Mensageria',
  MESSAGING_TRACKING: 'Rastreio de Mensageria',
  PDFS_REGENERATE: 'Regerar PDFs',
  POLICY_OCCURRENCE: 'Ocorrência Apólice',
  PRODUCTS_CHANGE: 'Alterar Produtos',
  READ: 'Leitura',
  REFUSE: 'Recusar',
  WALLET_BROKER_READ: 'Leitura Carteira Corretora',
  WALLET_BROKER_READ_2: 'Leitura carteira corretora',
  WALLET_COMPLETE_READ: 'Leitura Carteira Completa',
  ANNUAL_AUTO_COMPLETE_READ: 'Leitura Completa - Auto Anual',
  WALLET_COMPLETE_READ_2: 'Leitura de carteira completa',
  WALLET_CONSULTANCY_READ: 'Leitura Carteira Assessoria',
  WALLET_CONSULTANCY_READ_2: 'Leitura de carteira assessoria',
  WALLET_COVENANT_READ: 'Leitura Carteira Convênio',
  WALLET_COVENANT_READ_2: 'Leitura de carteira convênio',
  WRITE: 'Escrita',
  SUPPLIER_TYPES: 'Tipos de Fornecedor',
  ASSOCIATE_ACCESSORIES: 'Associar Acessorios',
  ASSOCIATE_MODELS: 'Associar Modelos',
  VALUES: 'Valores',
  LOCATIONS: 'Locais',
  SHOW_ALTERATIONS_HISTORY: 'Exibir Historico Alteracoes',
  BILLET_REPROCESS: 'Pode reprocessar boleto',
  OCCURRENCE: 'Ocorrência',
  REFUND_SETTLEMENT: 'Confirmar Restituição',
});
